type OccupancyBand = "OK" | "WARN" | "OVER" | "NONE";

const occupancyBand: OccupancyBand = "NONE";

export type { OccupancyBand };

export { occupancyBand };
